<template>
  <div 
    :class="{'hero-text--internalPage' : internalPage}"
    class="hero-text">
    <h1 v-if="heroH1 !== ''" v-html="heroH1"/>
    <h2 v-if="typeof heroH2 !== 'undefined'" v-html="heroH2"/>
    <p v-if="typeof heroP !== 'undefined'" v-html="heroP"/>
  </div>
</template>

<script>
export default {
  name: 'HeroText',
  props: {
    heroH1: {
      type: String,
      required: false
    },
    heroH2: {
      type: String,
      required: false
    },
    heroP: {
      type: String,
      required: false
    },
    internalPage: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
</style>
  